import React from 'react';

import PaginationBase from '../../../common/base/PaginationBase';
import global from '../../../common/utility/global';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { message } from 'antd';
import moment from 'moment';
import reporteOrdenCompraService from '../../../service/logistica/reporteOrdenCompraService';
import productoService from '../../../service/administracion/productoService';
import monedaService from '../../../service/administracion/monedaService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import proyectoService from '../../../service/administracion/proyectoService';
import marcaService from '../../../service/administracion/marcaService';
import proveedorService from '../../../service/administracion/proveedorService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingExcel: false,
            loadingPdf: false,
            loadingPdfRegistrado: false,
            productos: [],
            productosAll: [],
            establecimientos: [],
            marcas: [],
            monedas: [],
            proyectos: [],
            proveedores: [],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idMoneda: 0,
                idProducto: 0,
                idEstablecimiento: 0,
                idMarca: 0,
                idProyecto: 0,
                idProveedor: 0,
                tipoReporte: 1,
                referencia: '',
                serie: '',
                documento: '',
                ...FILTER
            },
            columnVisible: {
                tipo: 'hide',
                serie: 'hide',
                documento: 'hide',
                precioUnitario: 'hide',
                valorUnitario: 'hide',
                fecha: 'hide',
                tipoCambio: 'hide',
                nombreProveedor: 'hide',
                tipoDocumentoProveedor: 'hide',
                numeroDocumentoProveedor: 'hide',
                grupoConversionDolares: 'hide',
                subTotalConversionDolares: 'hide',
                igvConversionDolares: 'hide',
                totalConversionDolares: 'hide'
            },
            pagination: PAGINATION
        }
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idMoneda: 0,
            idProducto: 0,
            idEstablecimiento: 0,
            idMarca: 0,
            idProyecto: 0,
            idProveedor: 0,
            tipoReporte: 1,
            referencia: '',
            serie: '',
            documento: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = async (property, value) => {
        const MAX_MESES = 18;
        // Clonamos el filtro con el nuevo valor
        const filter = { ...this.state.filter, [property]: value };

        const { fechaInicioStr, fechaFinStr } = filter;

        // Solo validamos si ambas fechas existen
        if (fechaInicioStr && fechaFinStr) {
            const inicio = moment(fechaInicioStr, 'DD/MM/YYYY');
            const fin = moment(fechaFinStr, 'DD/MM/YYYY');

            const meses = fin.diff(inicio, 'months', true);

            if (meses > MAX_MESES) {
                message.error('El rango máximo permitido es de 18 meses');
                return; // ⛔ no actualiza el estado
            }
        }

        this.setState({ filter: filter });
        if (property === "tipoReporte" && value != 3) {
            this.setState({
                filter: {
                    ...this.state.filter,
                    idEstablecimiento: 0,
                    idProveedor: 0,
                    serie: '',
                    documento: '',
                    [property]: value
                },
            });
        }

    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true, filter: { ...this.state.filter, flagRegistrado: false } });
        var response = await reporteOrdenCompraService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Ventas por Producto.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true, filter: { ...this.state.filter, flagRegistrado: false } });
        var response = await reporteOrdenCompraService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Ventas por Producto.pdf");
    };

    handleExportPdfRegistrado = async () => {
        this.setState({ loadingPdfRegistrado: true, filter: { ...this.state.filter, flagRegistrado: true } });
        var response = await reporteOrdenCompraService.pdf(this.state.filter);
        this.setState({ loadingPdfRegistrado: false });

        var filename = "Reporte de Orden de Compra (Registrados).pdf"

        if (this.state.filter.TipoReporte === 3)
            filename = "Reporte de Orden de Compra (Registrados Detallado).pdf"

        if (response !== undefined)
            global.dowloadFile(response.data, filename);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };
    handlePagination = () => {
        this._handlePagination(this.state.filter, () => {
            this.setState({
                columnVisible: {
                    ...this.state.columnVisible,
                    precioUnitario: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    valorUnitario: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    nombreProveedor: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipoDocumentoProveedor: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    numeroDocumentoProveedor: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipo: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    serie: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    documento: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    fecha: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',
                    tipoCambio: this.state.filter.tipoReporte === 3 ? 'show' : 'hide',

                    grupoSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalSoles: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    subTotalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    igvDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',
                    totalDolares: ![SOLES, DOLARES_AMERICANOS].includes(parseInt(this.state.filter.idMoneda)) ? 'show' : 'hide',

                    grupoConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    subTotalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    igvConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',
                    totalConversionSoles: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'hide' : 'show',

                    grupoConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    subTotalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    igvConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide',
                    totalConversionDolares: parseInt(this.state.filter.idMoneda) === DOLARES_AMERICANOS ? 'show' : 'hide'
                },
            })
        });
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, reporteOrdenCompraService.paginacion);
        var productos = [];// await productoService.listar();
        var monedas = await monedaService.listar();
        var establecimientos = await establecimientoService.principales();
        const proyectos = await proyectoService.listar();
        const marcas = await marcaService.listar();
        var proveedores = await proveedorService.listar();

        if (monedas !== undefined)
            monedas.splice(0, 0, { id: '0', nombre: "MONEDA ORIGINAL" });

        this.setState({
            loadingSource: false,
            productos: productos ? productos : [],
            productosAll: productos ? productos : [],
            establecimientos: establecimientos ? establecimientos : [],
            monedas: monedas ? monedas : [],
            marcas: marcas ? marcas : [],
            proyectos: proyectos ? proyectos : [],
            proveedores: proveedores ? proveedores : [],


        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Reporte de Orden de Compra"
                    onSearch={this.handlePagination}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    productos={this.state.productos}
                    tipoProductos={this.state.tipoProductos}
                    establecimientos={this.state.establecimientos}
                    marcas={this.state.marcas}
                    monedas={this.state.monedas}
                    proyectos={this.state.proyectos}
                    proveedores={this.state.proveedores}
                    onKeyUpSearch={this.handleKeyUpInput}

                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    columnVisible={this.state.columnVisible}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPdfRegistrado={this.state.loadingPdfRegistrado}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    // onExportPdfRegistrado={this.handleExportPdfRegistrado}
                    onChange={this._handleChangePagination}
                />
            </div>
        )
    }
}